import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';

export default class GameOverPopup extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    const bg = ABCyaPhaser.Images.addImage(0,0,'end-popup-bg', this).setOrigin(0);

    const dialogTxt = ABCyaPhaser.Text.addText(bg.width / 2,60, 60, 0x433c49, FontKeys._cloudy_with_a_chance_of_lovRg, ABCyaPhaser.Localization.instance.getLocalizedString('game_over'), this, false).setOrigin(0.5);
    ABCyaPhaser.Text.resizeFontToFitWidth(dialogTxt, 365);

    this.playBtn = ABCyaPhaser.Images.addImage(bg.width / 2,0, 'btn-play-again', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
    const btnOffset = gameData.gameConfigs[gameData.game] === 'Food Groups' ? 10 : 0;
    this.playBtn.y = bg.height - this.playBtn.height - btnOffset;

    this.x = this.scene.scale.width / 2 - bg.width / 2;
    this.y = -bg.height;

    ABCyaPhaser.Audio.playOneShot('dialog-in', this.scene, 1, false, 0, gameData.gameModeSoundAtlas);
    ABCyaPhaser.Tweens.addTween(this, 1500, { delay: 500, y: this.scene.scale.height / 2 - bg.height / 2, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);

    this.playBtn.setInteractive().once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleInput, this);
  }

  handleInput () {
    ABCyaPhaser.Audio.playOneShot('button-click', this.scene, 1, false, 0, gameData.gameModeSoundAtlas);
    ABCyaPhaser.Tweens.addTween(this, 700, { y: -this.scene.scale.height / 2 }, Phaser.Math.Easing.Back.In, () => this.endPopUp());
  }

  endPopUp () {
    this.emit('END_DIALOG');

    this.destroy();
  }
}